<template>
  <LayoutPage>
    <template #aside>
      <CompositeAsideCard title="Consommation d'électricité" subtitle="Consommation du mois précédent"
        :key-info="store.getElectricity.energy_saved.toLocaleString('fr-FR')"
        key-info-label="kWh d'électricité consommés"
        tip-key-label="Le Grand Charles est chauffé et climatisé par la géothermie. ">
        <template #key-info-icon>
          <IconElectricityWhite />
        </template>
      </CompositeAsideCard>
    </template>
    <template #content>
      <CompositeChartSection class="electricity-consumption-chart-doughnut" title="Répartition de la consommation">
        <ChartDoughnut :topLeft="{ label: 'Bureaux', data: 30, unit: '%' }"
          :topRight="{ label: 'Autres', data: 20, unit: '%' }"
          :bottomLeft="{ label: 'Restaurant', data: 15, unit: '%' }"
          :bottomRight="{ label: 'Chauffage/Climatisation/Ventilation', data: 35, unit: '%' }"
          :dataset="{ backgroundColor: ['#6489c6', '#92a9d6', '#c4cfe9', '#2271b9'], data: [20, 35, 15, 30] }"
          :images="{ urls: images, size: 90 }">
          <p>Grand Charles</p>
          <IconGrandCharles class="icon-grand-charles" />
        </ChartDoughnut>

      </CompositeChartSection>
      <CompositeChartSection class="electricity-consumption-chart-lines" title="Consommation d'électricité"
        :chips="[{ title: new Date().getFullYear().toString(), backgroundColor: '#2271b9' }, { title: (new Date().getFullYear() - 1).toString(), backgroundColor: '#7c888f' }]">
        <ChartBars v-if="isMounted"
          :datasets="[{ backgroundColor: '#0072ce', data: store.getElectricity.chart_year_current }, { backgroundColor: '#737373', data: store.getElectricity.chart_year_before }]"
          :stepsize="50000" yAxisLegend="Consommation en kWh" />
      </CompositeChartSection>
    </template>
  </LayoutPage>
</template>

<script lang="ts" setup>
import LayoutPage from '@/components/layout/LayoutPage.vue'
import ChartDoughnut from '@/components/common/charts/ChartDoughnut.vue'
import ChartBars from '@/components/common/charts/ChartBars.vue'
import CompositeAsideCard from '@/components/composite/CompositeAside.vue'
import CompositeChartSection from '@/components/composite/CompositeChartSection.vue'
import IconElectricityWhite from '@/components/icons/IconElectricityWhite.vue'
import { useDataStore } from '@/stores/store_data'
import { onMounted, ref } from 'vue'
import IconGrandCharles from '@/components/icons/IconGrandCharles.vue'
import OfficesSvg from '@/assets/images/icons/bureaux.svg'
import RestaurantSvg from '@/assets/images/icons/restaurant.svg'
import OtherSvg from '@/assets/images/icons/autres.svg'
import HVACSvg from '@/assets/images/icons/climatisation.svg'


const store = useDataStore()

const isMounted = ref<boolean>(false)

const images = [
  OtherSvg,
  HVACSvg,
  RestaurantSvg,
  OfficesSvg,
]

onMounted(() => {
  store.fetchLGCData().then(() => {
    isMounted.value = true
  })
})
</script>

<style scoped lang="scss">
.electricity-consumption {
  &-chart-lines {
    width: 100%;
    height: 100%;
  }

  &-chart-doughnut {
    height: 100%;
    min-width: 35%;
  }
}

.container-icon-grand-charles {
  align-content: center;
  text-align: center;
  position: absolute;
  width: 180px;
  height: 90px;
  top: calc(50% - 60px);
  left: calc(50% - 85px);

  p {
    margin-bottom: 10px;
    color: var(--vc-primary);
    font-weight: 700;
    font-size: 26px;
  }
}
</style>
